import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';

export default function CancelSubscriptionModal({ isOpen, onClose, planName, cancelAt, processing, onConfirm }) {
  const [understood, setUnderstood] = useState(false);
  const { t } = useTranslation('billing');
  const { t: tc } = useTranslation('common');

  // Reset the checkbox each time the modal is (re)opened, so a previous
  // confirmation doesn't silently carry over to a later session.
  useEffect(() => {
    if (isOpen) setUnderstood(false);
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    await onConfirm();
    onClose();
  };

  const formattedDate = cancelAt
    ? new Date(cancelAt).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })
    : t('cancelModal.endOfPeriod');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content cancel-addon-modal" onClick={e => e.stopPropagation()}>
        <h3>{t('subscriptionCancelModal.title')}</h3>
        <p>
          <Trans
            t={t}
            i18nKey="subscriptionCancelModal.message"
            values={{ planName, date: formattedDate }}
            components={{ strong: <strong /> }}
          />
        </p>
        <label className="subscription-cancel-checkbox">
          <input
            type="checkbox"
            checked={understood}
            onChange={(e) => setUnderstood(e.target.checked)}
            disabled={processing}
          />
          {t('subscriptionCancelModal.checkboxLabel')}
        </label>
        <div className="modal-actions">
          <button
            className="btn-cancel-confirm"
            onClick={handleConfirm}
            disabled={!understood || processing}
          >
            {processing ? tc('processing') : t('subscriptionCancelModal.confirm')}
          </button>
          <button className="btn-cancel-back" onClick={onClose} disabled={processing}>
            {t('subscriptionCancelModal.back')}
          </button>
        </div>
      </div>
    </div>
  );
}
